import { Component,Input, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import * as SecureLS from "secure-ls";
import { ExcelServiceService } from "src/app/excel-service.service";
import { GlobalService } from "src/app/services/global.service";
@Component({
  selector: 'app-top-ten-viewed-videos',
  templateUrl: './top-ten-viewed-videos.component.html',
  styleUrls: ['./top-ten-viewed-videos.component.css']
})
export class TopTenViewedVideosComponent implements OnInit {
  @Input() roleId: number;
  private ls = new SecureLS({ encodingType: "aes" });
  videolist: any = [];
  recrange: any;
  constructor(
    public globalService: GlobalService,
    private spinner: NgxSpinnerService,
    private excelservice: ExcelServiceService
  ) { }

  ngOnInit(): void {
    this.getviewedvideolist(false);
  }
  async getviewedvideolist(isExcelExport) {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
    };
    let viewedvideolist = await this.globalService.get(
      "videolog/best/lecture",
      filter,
      true
    );
    this.spinner.hide();
    this.videolist = viewedvideolist["content"];
    if (isExcelExport) this.excelExport(viewedvideolist);
  }

  exportAsXLSX() {
    this.getviewedvideolist(true);
  }

  excelExport(uivideoList) {
    let uivideos = uivideoList['content'].map((item: any, i) => {
      return {
        S_NO: i+1,
        NAME: `${item.video_details.professor_details.first_name} ${item.video_details.professor_details.last_name}`,
        DEPARTMENT: item.video_details.department_details.name,
        CLASSROOM: item.video_details.classroom_details.name,
        SUBJECT: item.video_details.subject_details.name,
        DURATION: item.total_duration,
        START_DATE: item.video_details.start_date,
        START_TIME: item.video_details.start_time,
        END_DATE: item.video_details.end_date,
        END_TIME: item.video_details.end_time,
      };
    });

    this.excelservice.exportAsExcelFile(uivideos, "Top Ten Viewed Video Record");
  }
  getUtcToLocale(dateValue, timeValue, isDateRequested) {
    return this.globalService.getUtcToLocale(
      dateValue,
      timeValue,
      isDateRequested
    );
  }
}